module.exports = __webpack_public_path__ + "static/usecase_payment_right_bg@2x-961e3d5b3d306b882254b5b75cfce776.png";